module.exports = __webpack_public_path__ + "media/images/footer/koelnbusiness-cacb6be8736624c48c877752f7188fa6.png";